import { render, staticRenderFns } from "./ConfigurazioniMagazzinoArticoliImballoListComponent.vue?vue&type=template&id=834ca9f4"
import script from "./ConfigurazioniMagazzinoArticoliImballoListComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniMagazzinoArticoliImballoListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports